<template>
  <select
    :value="modelValue"
    @change="$emit('update:modelValue', $event.target.value)"
    class="text-xs border border-gray-200 rounded-lg px-2 py-1 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none bg-gray-50 text-gray-600"
  >
    <option value="day">Jour</option>
    <option value="week">Semaine</option>
    <option value="month">Mois</option>
  </select>
</template>

  <script>
export default {
  name: 'GroupBySelect',
  props: {
    modelValue: { type: String, default: 'day' }
  },
  emits: ['update:modelValue']
}
</script>
